import "./MessagesPage.css";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiRequest } from "services/apiRequest";
import { requestType } from "services/requests";
import { getMessagesData } from "features/message/messagesSlice";
import { useNavigate, useParams } from "react-router-dom";

import moment from 'moment';
import Navbar from "../Navbar/Navbar";
import Loader from "utilities/reusableComponent/Loader/Loader";
import FlagIcon from "assets/images/Mark Important Symbol.png";
import LikeIcon from "assets/images/Like.png";
import SadIcon from "assets/images/Sad.png";
import SmileIcon from "assets/images/Smile.png";
import LoveIcon from "assets/images/Love.png";
import TeacherIcon from "assets/images/teacher_default_icon.png";
import useEffectHook from "utilities/hook/useEffectHook";

function MessagesPage() {

  // get data from global state
  const { userInfo } = useSelector((state) => state.auth);
  const { totalUnreadMessage } = useSelector((state) => state.messages);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // variable state
  const [loading, setLoading] = useState(false);
  const [messagesData, setMessagesData] = useState([]);
  const [unreadMessage, setUnreadMessage] = useState(0);
  const [messageSelected, setMessageSelected] = useState('');
  const [detailMessage, setDetailMessage] = useState({});

  // extract params from url
  const { id } = useParams();
  const user = id !== undefined ? id?.split("-") : undefined;

  const handleClickmessageSelected = (uid, parent_name) => {
    const parentName = parent_name.replace(" ", "-");
    setMessageSelected(uid);
    navigate(`/messages/${uid}-${parentName}`);
  }

  // get messages data
  const getDataMessages = async() => {
    setLoading(true);
    const payload = {
      "user_uid": userInfo?.uid
    };

    const request = await apiRequest({
        requestType: requestType.getConversationsMessages,
        payload: {
            data: payload
        },
    })
    
    const response = await request?.data;

    if (response?.status === 0) {
      const conversationsData = response.data.conversations;
      const totalUnreadMessage = response.data.unread_messages_count;

      setMessagesData(conversationsData);
      // set default detail message 
      setMessageSelected(conversationsData.length > 0 ? getDefaultMessage(conversationsData) : '');
      // set unread message to local state
      setUnreadMessage(conversationsData.length > 0 ? totalUnreadMessage : 0);
      setLoading(false);
    } else {
      setLoading(false);
    }
  }

  // // function to get total unread message
  // const getMessagesUnread = (arr = []) => {
  //   let counts = 0;
  //   if(arr.length > 0) {
  //     arr.forEach((item) => {
  //       counts = counts + item.messages_unreacted_count;
  //     });
  //   }
  //   return counts;
  // }

  // function to get default message selected
  const getDefaultMessage = (arr = []) => {
    if(arr.length > 0 ) {
      const unreadMessage = arr.filter(d =>  d.reaction == null);
      unreadMessage.sort(function(a , b) {
        return b.uid - a.uid;
      });  
      setUnreadMessage(unreadMessage.length);
      return unreadMessage.length > 0 ? unreadMessage[0].uid : arr[0].uid;
    } else {
      return undefined
    }
  }

  // function to get detail message selected
  const getMessageSelected = async(uid) => {
    setLoading(true);
    const payload = {
      "user_uid": userInfo?.uid,
      "uid": user !== undefined ? user[0] : uid
    };

    const request = await apiRequest({
      requestType: requestType.getConversationMessages,
      payload: {
        data: payload
      },
    })
    const response = await request?.data;
    if (response?.status === 0) {
      setDetailMessage(response.data);
    } 
    setLoading(false);
  }

  const onClickMessageReaction = async(main_conversation, uid, reaction) => {
    setLoading(true);
    const payload = {
      "user_uid": userInfo?.uid,
      "uid": uid,
      "reaction": reaction
    };

    const request = await apiRequest({
      requestType: requestType.addMessagesReaction,
      payload: {
        data: payload
      },
    })
    
    const response = await request.data;
    if (response.status === 0) {
      getDataMessages();
      getMessageSelected(main_conversation);
      
      dispatch(getMessagesData(totalUnreadMessage - 1));
    } 
    setLoading(false);
  }

  // function to get detail message selected
  const getEmojiIcon = (emoji) => {
    let responseIcon = null;
    switch(emoji) {
      case 1:
        responseIcon = LikeIcon;
        break;
      case 2:
        responseIcon = LoveIcon;
        break;
      case 3:
        responseIcon = SadIcon;
        break;
      case 4:
        responseIcon = SmileIcon;
        break;
      default:
        responseIcon = SmileIcon;
    }
    return responseIcon;
  }

  useEffectHook(() => {
      getDataMessages();
    }, [], 0
  );

  useEffectHook(() => {
      // get detail message data
      if(messageSelected !== "") {
        getMessageSelected(messageSelected);
      }
    }, [messageSelected], 0
  );

  return (
    <>
      <div className="">
        <Navbar />
        <div className="max-w-screen-lg mx-auto">
          <div className="pt-[50px] w-full">
            <h1 className="font-gluten text-custom-navy font-bold text-4xl">
              Messages Overview <span className="text-custom-red">({unreadMessage})</span>
            </h1>
            {messagesData.length > 0 && (
              <div className="flex flex-row gap-10 mt-[40px] h-auto">
                <div className="w-[600px]">
                  {messagesData?.map((item, index) => {
                  return (
                    <div key={index} className="flex w-[550px] place-items-center border-t-2 border-salte-700 pt-5 pb-5 ">
                      {(user?.[0] == item.uid) && <div className="message-hover-bg"></div>}
                      <div className="w-20 z-10">
                          <div className="w-[60px] h-[60px] rounded-full border-[2px] border-custom-navy bg-white overflow-hidden flex-shrink-0">
                            <img
                              src={TeacherIcon}
                              className="w-[60px] h-[60px] object-contain"
                              alt=""
                            />
                          </div>
                      </div>
                      <div className="ml-3 w-[470px] text-[20px] z-10">
                        {item.messages_unreacted_count > 0 && 
                        <div className="message-notive">{item.messages_unreacted_count}</div>
                        } 
                        <div className="flex mb-1">
                          <div className="text-[22px] text-custom-navy font-bold cursor-pointer" onClick={ () => handleClickmessageSelected(item.uid, item.parent_name.toLowerCase())}>
                            {item.parent_name} (Parent)
                          </div>
                          {item.is_important === 1 && 
                            <img
                                src={FlagIcon}
                                className="w-[29px] h-[29px] ml-2"
                                alt=""
                            />
                          }
                        </div>
                        <div className="text-[18px] text-[#4F5E7B] mt-[10px] mb-[10px]">
                          {item.message.substring(0, 45)} ...
                        </div>
                        <div className="text-[#5A5A5A] text-sm font-bold opacity-[0.6]">
                          {moment(item.tstamp_create).format('hh:ssA')}
                        </div>
                      </div>
                      {item.reaction !== null &&
                        <div className="float-right z-10">
                          <div className="message-emoji-icon">
                            <img src={item.reaction !== null ? getEmojiIcon(item.reaction) : LikeIcon} className="flex-shrink-0" alt="" />
                          </div>
                        </div>
                      }
                    </div>
                  )})}
                </div>

                <div className="w-[400px] rounded-t-[40px] bg-custom-navy">
                  
                  {detailMessage?.conversation_messages?.length > 0 && (
                    <div className="message-detail">
                      <div className="text-center text-white mt-4">
                        <p className="text-xl font-normal">
                          {detailMessage?.child_details?.parent_details?.first_name}&nbsp;
                          {detailMessage?.child_details?.parent_details?.last_name}
                        </p>
                        <p className="text-[18px] text-inherit font-normal opacity-60">
                          {detailMessage?.child_details?.first_name?.toUpperCase()}&apos;S PARENT
                        </p>
                      </div>

                      <div className="message-contener">
                        {detailMessage?.conversation_messages.map((item, index) => {
                          const main_conversation = detailMessage?.conversation_messages[0].uid;
                          return (
                            <div key={index}>
                              <div className="bg-custom-yellow rounded-[22px] mt-6 mb-4 p-5">

                                {item.is_important === 1 && <div className="message-flag">
                                  <img
                                    src={FlagIcon}
                                    className="w-[48px] h-[48px] object-contain"
                                    alt=""
                                  />
                                </div>}
          
                                <div className="flex place-items-center">
                                  <div className="">
                                    <div className="w-[36px] h-[36px] rounded-full border-[2px] border-custom-navy bg-white overflow-hidden flex-shrink-0">
                                      <img
                                        src={TeacherIcon}
                                        className="w-full h-full object-contain"
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                  <div className="ml-3 text-[20px]">
                                    {detailMessage?.child_details?.parent_details?.first_name}&nbsp;
                                    {detailMessage?.child_details?.parent_details?.last_name}
                                  </div>
                                </div>
                                <p className="mt-4 mb-4">
                                  {item.message}
                                </p>
                                <div className="text-custom-gray text-sm font-semibold ">
                                  {moment(item.tstamp_create).format('DD/MM/YYYY HH:mmA')}
                                </div>
          
                                <div className="float-right mt-[-34px] mr-[-16px] ">
                                  <div className={`flex w-[48px] h-[48px] rounded-full border-[3px] border-white items-center justify-center ${item.reaction === null ? 'bg-[#D2D0D0]' : 'bg-custom-pink'} `}>
                                    <img
                                      src={item.reaction !== null ? getEmojiIcon(item.reaction) : LikeIcon}
                                      className="object-contain"
                                      alt=""
                                    />
                                  </div>
                                </div>
                              </div>
                              {item?.reaction === null &&
                                <div className="grid grid-cols-4 bg-white rounded-full mt-0 mb-6 p-3 justify-items-center">
                                  <div 
                                    className="flex w-[43px] h-[43px] rounded-full bg-custom-pink cursor-pointer items-center justify-center" 
                                    onClick={() => onClickMessageReaction(main_conversation, item.uid, 1)}
                                  >
                                    <img src={LikeIcon} className="w-[29px] h-[27px] flex-shrink-0" alt="" />
                                  </div>
                                  <div 
                                    className="flex w-[43px] h-[43px] rounded-full bg-custom-pink cursor-pointer items-center justify-center"
                                    onClick={() => onClickMessageReaction(main_conversation, item.uid, 2)}
                                  >
                                    <img src={LoveIcon} className="w-[32px] h-[32px] flex-shrink-0" alt="" />
                                  </div>
                                  <div 
                                    className="flex w-[43px] h-[43px] rounded-full bg-custom-pink cursor-pointer items-center justify-center"
                                    onClick={() => onClickMessageReaction(main_conversation, item.uid, 3)}
                                  >  
                                    <img src={SadIcon} className="w-[28px] h-[28px] flex-shrink-0" alt="" />
                                  </div>
                                  <div 
                                    className="flex w-[43px] h-[43px] rounded-full bg-custom-pink cursor-pointer items-center justify-center"
                                    onClick={() => onClickMessageReaction(main_conversation, item.uid, 4)}
                                  >
                                    <img src={SmileIcon} className="w-[28px] h-[28px] flex-shrink-0" alt="" />
                                  </div>
                                </div>
                              }
                            </div>
                          )
                        })}
                      </div>  
                    </div>
                  )}
                </div>
              </div>
            )}  
          </div>
        </div>
      </div>
      {loading && <Loader />}
    </>  
  );
}

export default MessagesPage;
